meedy.factory('meedy.accountingModel', ['$rootScope', 'meedy.baseModel', 'meedy.accountingService',
    function ($rootScope, baseModel, accountingService) {

        function AccountingModel() {

            this.nipExistence = function (nip) {
                accountingService.nipExistence(nip).then(
                    function (answer) {
                        $rootScope.$broadcast(Event.MEEDY.ACCOUNTING.NIP_EXISTENCE.SUCCESS, answer);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.ACCOUNTING.NIP_EXISTENCE.ERROR, error);
                    }
                )
            };

            this.regonExistence = function (regon) {
                accountingService.regonExistence(regon).then(
                    function (answer) {
                        $rootScope.$broadcast(Event.MEEDY.ACCOUNTING.REGON_EXISTENCE.SUCCESS, answer);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.ACCOUNTING.REGON_EXISTENCE.ERROR, error);
                    }
                )
            };

        }

        return new AccountingModel();
    }
]);
